import { FaIcon } from '@ifixit/ui/components/icon';
import { BlueDot } from '../../misc';

interface CartDrawerTriggerProps {
   onClick?: () => void;
   hasItemsInCart?: boolean;
}

export function CartDrawerTrigger({ onClick, hasItemsInCart }: CartDrawerTriggerProps) {
   return (
      <div className="relative">
         <button
            type="button"
            aria-label="Open cart"
            className="flex size-10 cursor-pointer items-center justify-center rounded border-0 bg-transparent outline-none transition-opacity duration-300 hover:opacity-70 focus-visible:ring-[3px] focus-visible:ring-brand-400/70"
            onClick={onClick}
            data-testid="cart-drawer-open"
         >
            <FaIcon name="cart-shopping" className="size-6 text-white" />
         </button>
         {hasItemsInCart && <BlueDot className="absolute top-0.5 right-0.5" />}
      </div>
   );
}
